import { createAction } from '@ngrx/store';

export const AddSuccessNotification = createAction(
  '[Form] Add Success Notification',
  (payload = null) => ({ payload })
);
export const AddFailureNotification = createAction(
  '[Form] Add Failure Notification',
  (payload = null) => ({ payload })
);
export const RemoveNotification = createAction(
  '[Form] Remove Notification',
  (payload = null) => ({ payload })
);
